import clsx from 'clsx';
import { LockIcon } from 'lucide-react';
import type React from 'react';

type Props = {
  children?: React.ReactNode;
  className?: string;
};

export const ProTierPreview = ({ children, className }: Props) => (
  <div
    className={clsx(
      'pointer-events-none absolute left-0 top-0 flex h-full w-full items-center justify-center bg-background/90 backdrop-opacity-20 transition-all duration-500 group-hover:bg-background/0 group-active:bg-background/0',
      className,
    )}
  >
    <div className="mb-4 flex flex-col items-center gap-2 text-center text-sm text-muted-foreground transition-all duration-300 group-hover:opacity-0 group-active:opacity-0">
      {children ? (
        children
      ) : (
        <div className="flex flex-col items-center gap-1">
          <span className="text-orange-800 dark:text-orange-200 flex items-center gap-1.5">
            <LockIcon size={16} />
            Not available on current plan
          </span>
          <div className="select-none">
            <p className="hidden sm:block">Hover over for preview with mock data</p>
            <p className="block sm:hidden">Press and hold for preview with mock data</p>
          </div>
        </div>
      )}
    </div>
  </div>
);
